import { render, staticRenderFns } from "./MoveToModal.vue?vue&type=template&id=d542a838&scoped=true"
import script from "./MoveToModal.vue?vue&type=script&lang=js"
export * from "./MoveToModal.vue?vue&type=script&lang=js"
import style0 from "./MoveToModal.vue?vue&type=style&index=0&id=d542a838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d542a838",
  null
  
)

export default component.exports